import { jsx as _jsx } from "react/jsx-runtime";
import { Controls, ReactFlow, ReactFlowProvider, applyNodeChanges } from "@xyflow/react";
import "@xyflow/react/dist/style.css";
import React, { memo, useCallback, useEffect, useMemo } from "react";
import { AddAssetNode } from "../CustomNodes/AddAssetNode";
import { NodeIconType } from "../CustomNodes/CustomNodeEnums";
import { UtilityPowerNode } from "../CustomNodes/UtilityPowerNode";
import { UtilityProviderNode } from "../CustomNodes/UtilityProviderNode";
const AddAssetNetworkDiagramUI = ({ assetList }) => {
    const [nodes, setNodes] = React.useState([]);
    const defaultViewport = { x: 0, y: 0, zoom: 0.5 };
    const onNodesChange = useCallback((changes) => {
        setNodes((nds) => applyNodeChanges(changes, nds));
    }, [setNodes]);
    const getAssetIconType = (type) => {
        switch (type) {
            case "ESS":
                return NodeIconType.ESSBOX;
            case "Machine":
                return NodeIconType.EXCAVATOR;
            default:
                return NodeIconType.EXCAVATOR;
        }
    };
    const getNetworkNodes = (assetList) => {
        const nodeList = [];
        const FIRST_NODE_Y_VALUE = 100;
        const ESS_X_VALUE = 750;
        const MACHINE_X_VALUE = 900;
        let ESS_Y_VALUE = FIRST_NODE_Y_VALUE;
        let MACHINE_Y_VALUE = FIRST_NODE_Y_VALUE;
        const ADD_VALUE = 150;
        const utilityPowerNodePosition = { x: 300, y: 340 };
        const chargeStationNodePosition = { x: 450, y: 250 };
        nodeList.push({
            data: {},
            id: "Power",
            position: utilityPowerNodePosition,
            type: "utilityPowerNode"
        });
        nodeList.push({
            data: { label: " Utility Provider" },
            id: "utilityProviderNode",
            position: chargeStationNodePosition,
            type: "utilityProviderNode"
        });
        assetList.forEach((asset) => {
            const { assetId, serialNumber, type } = asset;
            if (type === "ESS") {
                nodeList.push({
                    data: {
                        columnTitle: ESS_X_VALUE === 750 && ESS_Y_VALUE === FIRST_NODE_Y_VALUE ? "ESS #" : "",
                        iconType: getAssetIconType(type),
                        label: serialNumber.substring(0, 5)
                    },
                    id: assetId,
                    position: { x: ESS_X_VALUE, y: ESS_Y_VALUE },
                    type: "addAssetNode"
                });
                ESS_Y_VALUE = ESS_Y_VALUE + ADD_VALUE;
            }
            if (type === "Machine") {
                nodeList.push({
                    data: {
                        columnTitle: MACHINE_X_VALUE === 900 && MACHINE_Y_VALUE === FIRST_NODE_Y_VALUE ? "Asset #" : "",
                        iconType: getAssetIconType(type),
                        label: serialNumber.substring(0, 3)
                    },
                    id: assetId,
                    position: { x: MACHINE_X_VALUE, y: MACHINE_Y_VALUE },
                    type: "addAssetNode"
                });
                MACHINE_Y_VALUE = MACHINE_Y_VALUE + ADD_VALUE;
            }
        });
        return nodeList;
    };
    const nodeTypes = useMemo(() => ({
        addAssetNode: AddAssetNode,
        utilityPowerNode: UtilityPowerNode,
        utilityProviderNode: UtilityProviderNode
    }), []);
    useEffect(() => {
        const nodeListInfo = getNetworkNodes(assetList);
        setNodes(nodeListInfo);
    }, [assetList]);
    return (_jsx("div", { className: "h-[100%] w-[100%]", children: _jsx(ReactFlow, { className: "bg-gray-100", "data-test": "add-asset-network-diagram-react-flow", deleteKeyCode: null, edges: [
                {
                    id: "p",
                    source: "Power",
                    style: { border: "1px solid #000000", strokeWidth: 3 },
                    target: "utilityProviderNode"
                }
            ], nodeTypes: nodeTypes, nodes: nodes, nodesDraggable: false, onInit: (instance) => {
                instance.setViewport(defaultViewport);
            }, onNodesChange: onNodesChange, proOptions: { hideAttribution: true }, children: _jsx(Controls, { "data-test": "add-asset-network-diagram-controls", position: "bottom-right", showFitView: false, showInteractive: false }) }) }));
};
const AddAssetNetworkDiagram = (props) => {
    return (_jsx(ReactFlowProvider, { children: _jsx(AddAssetNetworkDiagramUI, { ...props }) }));
};
export default memo(AddAssetNetworkDiagram);
